// src/components/PsicomotricidadeInfo.tsx
import React from 'react';
import '../../styles/especialidades.css';

const NeurologistaInfo: React.FC = () => (
    <section className="about_psicomotricidade">
        <div className="teste_zoom_two">
            <div className="about_text_psicomotricidade">
                <h2 className='sub_title'><b>Despertando potencialidades, construindo futuros.</b></h2>
                <br />
                <p>A atuação da Pedagoga é essencial no processo de aprendizagem e no desenvolvimento integral da criança, do adolescente e até do adulto em contextos educativos e sociais. Com um olhar sensível e estratégias pedagógicas personalizadas, o trabalho pedagógico busca compreender as necessidades individuais e estimular o crescimento cognitivo, emocional e social.</p>
                <br />
                <p>Durante os atendimentos, são desenvolvidas ações que promovem a autonomia, o prazer pelo aprender e o fortalecimento da autoestima. O objetivo é transformar dificuldades em oportunidades, respeitando o tempo e o ritmo de cada indivíduo.</p>
                <br />
                <p><b>Quando procurar o acompanhamento pedagógico?</b></p>
                <br />
                <p>Ele é indicado em situações como:</p>
                <li>Dificuldades de aprendizagem ou defasagens escolares;</li>
                <li>Desmotivação, baixa autoestima ou insegurança no ambiente escolar;</li>
                <li>Problemas de atenção, concentração ou organização nos estudos;</li>
                <li>Necessidade de reforço escolar ou adaptação pedagógica;</li>
                <li>Acompanhamento de crianças com necessidades educacionais especiais;</li>
                <li>Orientação às famílias quanto ao processo de aprendizagem e desenvolvimento.</li>
                <br />
                <p><b>Benefícios do acompanhamento pedagógico</b></p>
                <br />
                <p>Investir no apoio pedagógico proporciona:</p>
                <li>Melhora no desempenho escolar e nas habilidades cognitivas;</li>
                <li>Desenvolvimento de estratégias de estudo mais eficazes;</li>
                <li>Fortalecimento da autoconfiança e da motivação para aprender;</li>
                <li>Maior integração entre escola, aluno e família;</li>
                <li>Promoção de uma aprendizagem mais significativa e prazerosa.</li>
                <br />
                <p><b>A pedagogia como ponte entre desafios e conquistas</b></p>
                <br />
                <p>Mais do que ensinar conteúdos, o trabalho pedagógico é uma jornada de descoberta e empoderamento. Com escuta, acolhimento e técnica, a pedagoga contribui para que cada aluno encontre seu caminho na educação e na vida.</p>

            </div>
        </div>
    </section>
);

export default NeurologistaInfo;